<script setup>
const props = defineProps({
    title: String,
    slug: String,
    excerpt: String,
    featured_image: String,
    author: String,
    published_at: String,
    tags: Array
})
</script>

<template>
<div class="bg-gray-50 rounded-lg shadow p-4 flex flex-col items-start max-w-sm my-2 mx-2">
    <div class="w-full mb-4">
        <a :href="route('web.blogs.' + slug)">
        <img :src="`/images/web/${featured_image}`" class="rounded-lg w-full h-40 object-cover" alt="img" />
        </a>
    </div>
    <div class="w-full text-left">
        <p class="text-xs text-gray-500 mb-2 flex items-center">{{ author }} <span class="mx-1">•</span> {{ published_at }}</p>
        <h2 class="font-semibold mb-2">
        <a :href="route('web.blogs.' + slug)">{{ title }}</a>
        </h2>
        <p class="text-sm text-gray-700 mb-3 line-clamp-2">{{ excerpt }}</p>
        <div class="flex flex-wrap gap-2">
        <span class="bg-blue-100 text-blue-700 rounded px-2 py-1 text-xs" v-for="tag in tags" :key="tag">{{ tag }}</span>
        </div>
    </div>
</div>
    
</template>


